const UNLOCKED = 'unlocked';
const LOCKED = 'locked';
const PARTIALLY_LOCKED = 'partial';

export {
  UNLOCKED,
  LOCKED,
  PARTIALLY_LOCKED,
};
